<template>
    <component :is="element" v-if="$can(perform, on)">
        <slot></slot>
    </component>
</template>

<script>
    export default {
        props: {
            perform: {
                required: true,
                type: String,
            },
            on: {
                required: true,
                type: Object,
            },
            element: {
                required: false,
                type: String,
                default: 'span',
            }
        }
    }
</script>